import { apiClient } from './api';

// EG-52 — Platform Admin xem nhân viên cross-tenant.
// BE endpoint: GET /staffs, GET /staffs/:id (read-only).

export interface StaffFilters {
  page?: number;
  limit?: number;
  tenant_id?: string;
  q?: string;
  state?: number;
}

export interface Staff {
  staff_id: string;
  tenant_id?: string;
  name: string;
  username: string;
  email: string;
  phone?: string;
  state: number;
  two_fa_enabled?: boolean;
  department_id?: string;
  created_at: string;
  updated_at?: string;
}

export interface StaffsResponse {
  data: Staff[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

interface StaffApiRaw {
  staff_id?: string;
  _id?: string;
  tenant_id?: string;
  name?: string;
  username?: string;
  email?: string;
  phone?: string;
  state?: number;
  two_fa_enabled?: boolean;
  department_id?: string;
  created_at?: string;
  updated_at?: string;
}

const toStaff = (raw: StaffApiRaw): Staff => ({
  staff_id: raw.staff_id || raw._id || '',
  tenant_id: raw.tenant_id,
  name: raw.name || '',
  username: raw.username || '',
  email: raw.email || '',
  phone: raw.phone,
  state: raw.state ?? 0,
  two_fa_enabled: raw.two_fa_enabled,
  department_id: raw.department_id,
  created_at: raw.created_at || '',
  updated_at: raw.updated_at,
});

export const staffService = {
  getStaffs: async (filters: StaffFilters = {}): Promise<StaffsResponse> => {
    const response = await apiClient.get<Envelope<{ items: StaffApiRaw[]; meta: StaffsResponse['meta'] }>>(
      '/staffs',
      { params: filters },
    );
    const payload = response.data?.data;
    return {
      data: (payload?.items || []).map(toStaff),
      meta: payload?.meta || {
        page: filters.page || 1,
        limit: filters.limit || 20,
        total: 0,
        totalPages: 0,
      },
    };
  },

  getStaffById: async (id: string): Promise<Staff> => {
    const response = await apiClient.get<Envelope<StaffApiRaw>>(`/staffs/${id}`);
    return toStaff(response.data.data);
  },
};

export default staffService;
